import { useDraggable } from '@dnd-kit/core'

interface DraggableItemProps {
  id: string | number
  className?: string
  data?: Record<string, any>
  children: React.ReactNode
}

export const DraggableItem = ({ id, className, data, children }: DraggableItemProps): JSX.Element => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data,
  })

  return (
    <div className={className} ref={setNodeRef} {...attributes} {...listeners}>
      {children}
    </div>
  )
}
